import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$2535 November sidehustle report",
  "description": "",
  "published": "2017-12-04T00:00:00.000Z",
  "redirect_from": ["/blog/2017-november-sidehustle-report/swizec/7946"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know how `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/16661-october-sidehustle-report/swizec/7883"
      }}>{`last month`}</a>{` was huge and money rained from the sky? November, not so much.`}</p>
    <p>{`Didn't even break even.`}</p>
    <p>{`That's one of the main surprises for my friends about running a business. They see a report like last month's and their eyes go wide and they whisper amongst each other and crack jokes about how much money I have. They ignore the other reports.`}</p>
    <p>{`What they forget is that a spike is not a trend. It can indicate a trend, but it rarely means you're going to be making that much or more from now until eternity.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/12/Screen-Shot-2017-12-03-at-11.06.58.png",
        "alt": null
      }}></img></p>
    <p>{`November was bad. Sure, there was a lot going on, attempts were made, but ultimately not much happened. Running a sale like my 30-at-30 promotion is like frontloading your customers.`}</p>
    <p>{`You get an infusion of money now and it's great, but those people from your audience aren't going to be ready to buy anything else for a while. So instead of a trickle of sales every week for the next few months, you compact all those future sales into `}<em parentName="p">{`now`}</em>{`.`}</p>
    <p>{`That's kinda what happened. Going to take a while for regular sales to rebound. Gonna need to develop some new products too.`}</p>
    <p>{`Like that Intro to React and Redux video course I promised. Working on it :)`}</p>
    <p>{`You may also have noticed that I haven't been publishing as much in November. That's because I was working on a lot of things that are going to show up in December's report.`}</p>
    <p>{`Some stuff I can't talk about yet, other stuff you've likely already seen. Like the `}<a parentName="p" {...{
        "href": "https://bestjavascript.io"
      }}>{`JS Bundle`}</a>{` we put out with a bunch of other authors.`}</p>
    <p>{`If you haven't seen that, then our marketing sucks.`}</p>
    <p>{`Actually… I'm gonna have some thoughts on that soonish 🤔 Because it did not go as well as I'd hoped 😅`}</p>
    <p>{`Anyway, here's November in numbers 👇`}</p>
    <p><strong parentName="p">{`Total revenue`}</strong>{` $2249`}</p>
    <p><strong parentName="p">{`Gumroad sales`}</strong>{` $1309 - `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React D3v4`}</a>{`: $1272 - `}<a parentName="p" {...{
        "href": "https://es2017.io"
      }}>{`JS cheatsheet - es2017`}</a>{`: $37`}</p>
    <p><strong parentName="p">{`Leanpub sales`}</strong>{` $392 - React D3v4: $348 - React D3 old versions: $25 - `}<a parentName="p" {...{
        "href": "http://nightowlsbook.com"
      }}>{`Why Programmers work at Night`}</a></p>
    <p><strong parentName="p">{`Patreon pledges`}</strong>{` $211`}</p>
    <p><strong parentName="p">{`Educative`}</strong>{` $274 - React D3v4 course: $274`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 78 hours`}</p>
    <p><strong parentName="p">{`Expenses →`}</strong></p>
    <ul>
      <li parentName="ul">{`Editor: $500`}</li>
      <li parentName="ul">{`VA: $400`}</li>
      <li parentName="ul">{`Facebook ads: $985`}</li>
      <li parentName="ul">{`Twitter ads: $600`}</li>
      <li parentName="ul">{`Reddit ads: $36`}</li>
      <li parentName="ul">{`Drip: $149`}</li>
      <li parentName="ul">{`SumoMe: $99`}</li>
      <li parentName="ul">{`Webfaction: $10`}</li>
      <li parentName="ul">{`LiveEdu Pro: $10`}</li>
      <li parentName="ul">{`AWS: $14`}</li>
      <li parentName="ul">{`now.sh: $15`}</li>
      <li parentName="ul">{`bestjavascript.io domain: $46`}</li>
      <li parentName="ul">{`domainsquatting for ES6 domains: $149`}</li>
      <li parentName="ul">{`SmartBribe: $35`}</li>
      <li parentName="ul">{`mailchimp: $20`}</li>
      <li parentName="ul">{`MicroConf April ticket: $918`}</li>
      <li parentName="ul">{`DJI Spark: $649`}</li>
    </ul>
    <p><strong parentName="p">{`Effective hourly rate:`}</strong>{` -$44/hour 😂`}</p>
    <p>{`Okay okay, the accounting for this month is weird. The DJI Spark will serve me for months if not years. Real accountants look at things like that using something called `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Amortization"
      }}>{`amortization`}</a>{`.`}</p>
    <p>{`You say `}<em parentName="p">{`"Okay, this cost $649 and has an effective lifespan of 24 months. Therefore, it costs $27/month"`}</em>{`. But I'm lazy so I make that calculation in my head to decide if buying something is worth it, then put it in my reports as a one-time cost.`}</p>
    <p>{`It all evens out in the end. As long as the average trend across months is up 📈 I'm okay.`}</p>
    <p>{`PS: The hella expensive ads were for the JS Bundle, the revenue of which comes next month.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      